// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"10":"b3a6a48788e856f4435c68da24429e40f10fb7ec","678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"10":"95f0993b373b90638266","678":"03615996e617a382a419","713":"a93158de14fda72f93ff","883":"bbf462aca72b48e9edd2"}[chunkId] + ".js";
};